// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-kg {
  font-size: 14px !important;
  font-weight: 400 !important;
  padding: 8px 16px !important;
  text-transform: none !important;
  font-family: "Open Sans", sans-serif !important;
  letter-spacing: unset !important;
  line-height: unset !important;
  min-width: 20px !important;
  max-height: 36px;

  &.green-outline {
    outline: 1px solid var(--primary-main) !important;
    background-color: white !important;
    color: var(--primary-main) !important;
    border-radius: 4px !important;
  }

  &.green:disabled {
    cursor: none;
    background-color: #d0d0ce !important;
    color: #63666a !important;
    outline: 1px solid #d0d0ce !important;
  }

  &.green {
    border-radius: 4px !important;
    background-color: var(--primary-main) !important;
    outline: 1px solid var(--primary-main) !important;
    color: white !important;
  }

  &.medium {
    padding: 8px 10px !important;
    width: 36px;
    height: 36px;
  }

  &.small {
    padding: 4px 8px !important;
  }
}

.btn-default {
  color: inherit;
  border: none;
  font: inherit;
  font-family: "Open Sans", sans-serif !important;
  cursor: pointer;
  outline: inherit;
}

.btn-default-style {
  background: none;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/app.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,+CAA+C;EAC/C,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;;EAEhB;IACE,iDAAiD;IACjD,kCAAkC;IAClC,qCAAqC;IACrC,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,oCAAoC;IACpC,yBAAyB;IACzB,qCAAqC;EACvC;;EAEA;IACE,6BAA6B;IAC7B,gDAAgD;IAChD,iDAAiD;IACjD,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":[".button-kg {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  padding: 8px 16px !important;\n  text-transform: none !important;\n  font-family: \"Open Sans\", sans-serif !important;\n  letter-spacing: unset !important;\n  line-height: unset !important;\n  min-width: 20px !important;\n  max-height: 36px;\n\n  &.green-outline {\n    outline: 1px solid var(--primary-main) !important;\n    background-color: white !important;\n    color: var(--primary-main) !important;\n    border-radius: 4px !important;\n  }\n\n  &.green:disabled {\n    cursor: none;\n    background-color: #d0d0ce !important;\n    color: #63666a !important;\n    outline: 1px solid #d0d0ce !important;\n  }\n\n  &.green {\n    border-radius: 4px !important;\n    background-color: var(--primary-main) !important;\n    outline: 1px solid var(--primary-main) !important;\n    color: white !important;\n  }\n\n  &.medium {\n    padding: 8px 10px !important;\n    width: 36px;\n    height: 36px;\n  }\n\n  &.small {\n    padding: 4px 8px !important;\n  }\n}\n\n.btn-default {\n  color: inherit;\n  border: none;\n  font: inherit;\n  font-family: \"Open Sans\", sans-serif !important;\n  cursor: pointer;\n  outline: inherit;\n}\n\n.btn-default-style {\n  background: none;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
